import React from 'react'
import PropTypes from 'prop-types'
import pure from 'recompose/pure'
import withTheme from '@material-ui/core/styles/withTheme'
import FaPinterest from 'react-icons/lib/fa/pinterest-p'
import FaTwitter from 'react-icons/lib/fa/twitter'
import IoSocialInstagram from 'react-icons/lib/io/social-instagram'
import FaGooglePlus from 'react-icons/lib/fa/google-plus'
import FaFacebook from 'react-icons/lib/fa/facebook'
import Typography from '@material-ui/core/Typography'

const SocialIcon = ({ theme, Icon, url, title, bright }) => {
  if (!Icon) {
    throw new Error('You must provide a social media icon.')
  }
  if (!url) {
    throw new Error('Please provide a URL to redirect to.')
  }

  return (
    <a href={url} target="_blank" style={{ margin: '0 4px' }} title={title}>
      <Icon
        style={{
          color: bright ? '#fff' : theme.palette.primary.dark,
          border: `1px solid ${bright ? '#fff' : theme.palette.primary.dark}`,
          borderRadius: '50%',
          padding: 5,
          fontSize: '1.9em',
        }}
      />
      <style>{`
        a:hover {
          opacity: 0.7;
        }
        `}</style>
    </a>
  )
}
SocialIcon.propTypes = {
  Icon: PropTypes.any.isRequired,
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  bright: PropTypes.bool,
}

const EnhancedSocialIcon = withTheme()(pure(SocialIcon))

const FollowBar = ({ height, bright }) => (
  <div
    style={{
      height: height || 120,
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <div style={{ padding: 5 }}>
      <Typography
        align="center"
        variant="title"
        style={{
          textTransform: 'uppercase',
          marginBottom: 8,
          fontWeight: 600,
          color: bright && '#fff',
        }}
      >
        Follow
      </Typography>
      <EnhancedSocialIcon
        Icon={FaPinterest}
        url={process.env.PINTEREST_URL}
        title="Pinterest"
        bright={bright}
      />
      <EnhancedSocialIcon
        Icon={FaFacebook}
        url={process.env.FACEBOOK_PAGE}
        title="Facebook"
        bright={bright}
      />
      <EnhancedSocialIcon
        Icon={FaTwitter}
        url={process.env.TWITTER_URL}
        title="Twitter"
        bright={bright}
      />
      <EnhancedSocialIcon
        Icon={IoSocialInstagram}
        url={process.env.INSTAGRAM_URL}
        title="Instagram"
        bright={bright}
      />
      <EnhancedSocialIcon
        Icon={FaGooglePlus}
        url={process.env.GOOGLEPLUS_URL}
        title="Google Plus"
        bright={bright}
      />
    </div>
  </div>
)

FollowBar.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  bright: PropTypes.bool,
}

export default pure(FollowBar)



// WEBPACK FOOTER //
// ./src/components/Footer/FollowBar.js